import React from "react";
import { connect } from "react-redux";
import qs from "query-string";
import { Container, Row, Col } from "react-bootstrap";

import { NavBar, ContentWrapper } from "../components/Nav";
import { Footer } from "../components/Footer";
import { LoginModal } from "../components/Modal";
import "./styles/Landing.scss";

import { validateThenLogin } from "../actions/auth";
import { submitEmail } from "../actions/userData";

class Landing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      loginModal: true,
      email: "",
      emailSubmitError: this.props.userData.emailSubmitError,
      emailSubmitSuccess: this.props.userData.emailSubmitSuccess
    };
  }

  componentDidMount() {
    // get jwt from url
    const params = qs.parse(this.props.location.search);
    if (params.token) {
      // update redux
      this.props.validateThenLogin(params.token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.userData !== nextProps.userData) {
      this.setState({
        emailSubmitError: nextProps.userData.emailSubmitError,
        emailSubmitSuccess: nextProps.userData.emailSubmitSuccess
      });
    }
  }

  handleEmailChange = e => {
    this.setState({
      email: e.target.value,
      emailSubmitError: undefined,
      emailSubmitSuccess: undefined
    });
  };

  render() {
    return (
      <div>
        <NavBar
          onButtonClick={clickedID =>
            this.setState({
              modalIsOpen: true,
              loginModal: clickedID === "login"
            })
          }
        />

        <ContentWrapper>
          <LoginModal
            open={this.state.modalIsOpen}
            onClose={() => this.setState({ modalIsOpen: false })}
            loginModal={this.state.loginModal}
            onSignUpClick={() => this.setState({ loginModal: false })}
            onLoginClick={() => this.setState({ loginModal: true })}
          />

          <div id="hero" className="parallax">
            <h1>
              Stolen mail is
              <br />
              so last year.
            </h1>
            <button
              onClick={() =>
                document.getElementById("emailUpdates").scrollIntoView()
              }
            >
              Join the Waitlist
            </button>
          </div>

          <div id="mapDiv">
            <div className="underlapImage" />
            <div className="overlapText">
              <h1>Your personal PO box, everywhere.</h1>
              <p>
                Get your packages sent to any SafeBox near you – we have
                locations all over the city.
              </p>
              <a href="/">Learn more &#8594;</a>
            </div>
          </div>

          <div id="howItWorks">
            <h1>How it works</h1>
            <Container>
              <Row>
                <Col sm={{ order: 1, span: 4 }} className="imgContainer">
                  <img
                    src={require("../assets/pictures/1.png")}
                    alt="click button"
                  />
                </Col>
                <Col sm={{ order: 4, span: 4 }}>
                  <h3>Install in seconds</h3>
                  <p>It takes just 2 clicks and it’s 100% free.</p>
                </Col>

                <Col sm={{ order: 2, span: 4 }} className="imgContainer">
                  <img
                    src={require("../assets/pictures/2.png")}
                    alt="computer"
                  />
                </Col>
                <Col sm={{ order: 5, span: 4 }}>
                  <h3>Shop like normal</h3>
                  <p>
                    Choose whichever SafeBox location is convenient for you.
                  </p>
                </Col>

                <Col sm={{ order: 3, span: 4 }} className="imgContainer">
                  <img
                    src={require("../assets/pictures/3.png")}
                    alt="package"
                  />
                </Col>
                <Col sm={{ order: 6, span: 4 }}>
                  <h3>Pick up your stuff</h3>
                  <p>
                    We’ll send you an email or text message to unlock your
                    SafeBox.
                  </p>
                </Col>
              </Row>
            </Container>
          </div>

          <div id="productTarget" className="parallax">
            <div className="underlapImage" />
            <div className="overlapText">
              <h1>Get your products in front of who you want.</h1>
              <p>
                We survey our users to understand who they are and what they
                buy.
              </p>
              <a href="/">Learn more &#8594;</a>
            </div>
          </div>

          <div id="emailUpdates" ref={this.selector}>
            <p>
              Sign up with your email address to receive news and updates when
              SafeBox goes live.
            </p>
            <form onSubmit={e => e.preventDefault()}>
              <div className="emailInput">
                <input
                  placeholder="Email Address"
                  type="email"
                  onChange={this.handleEmailChange}
                />
                <button
                  onClick={() => this.props.submitEmail(this.state.email)}
                >
                  SIGN UP
                </button>
              </div>
              {this.state.emailSubmitError && (
                <p style={{ color: "red" }}>Server Error</p>
              )}
              {this.state.emailSubmitSuccess && (
                <p style={{ color: "green" }}>Success!</p>
              )}
            </form>
          </div>

          <Footer />
        </ContentWrapper>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  validateThenLogin: token => dispatch(validateThenLogin(token)),
  submitEmail: email => dispatch(submitEmail(email))
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Landing);
